export const USER_GROUP_SOURCE_TYPES = {
  SLACK_GROUP: 'slackGroup',
  SCIM_GROUP: 'scimGroup',
  SYSTEM: 'system',
} as const;

export type UserGroupSourceType = (typeof USER_GROUP_SOURCE_TYPES)[keyof typeof USER_GROUP_SOURCE_TYPES];

export const USER_GROUP_SOURCE_LABELS = {
  [USER_GROUP_SOURCE_TYPES.SLACK_GROUP]: 'Slack Group',
  [USER_GROUP_SOURCE_TYPES.SCIM_GROUP]: 'SCIM Group',
  [USER_GROUP_SOURCE_TYPES.SYSTEM]: 'System',
};

export interface UserGroup {
  id: string;
  name: string;
  description: string;
  filters: any[];
  sourceType?: UserGroupSourceType;
  sourceId?: string;
  isExternal?: boolean;
  photo?: string;
  notificationChannelId?: string;
}
